import { createRouter, createWebHistory } from "vue-router";
import { authStore } from "@/stores/authStores";
import i18n from "@/i18n";

import AdminLogin from "@/views/AdminLogin.vue";
import AdminDashboard from "@/views/AdminDashboard.vue";
import AdminSections from "@/views/AdminSections.vue";
import Home from "@/views/Home.vue";
import News from "@/views/News.vue";
import Sections from "@/views/Sections.vue";
import Teachers from "@/views/Teachers.vue";
import Contact from "@/views/Contact.vue";
import NotFound from "@/views/404.vue";

const routes = [
  {
    path: "/admin",
    name: "AdminLogin",
    component: AdminLogin,
    meta: { requiresGuest: true },
  },
  {
    path: "/admin/dashboard",
    name: "AdminDashboard",
    component: AdminDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/sections",
    name: "AdminSections",
    component: AdminSections,
    meta: { requiresAuth: true },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      titleKey: "seo.home.title",
      descriptionKey: "seo.home.description",
    },
  },
  {
    path: "/news",
    name: "News",
    component: News,
    meta: {
      titleKey: "seo.news.title",
      descriptionKey: "seo.news.description",
    },
  },
  {
    path: "/sections",
    name: "Sections",
    component: Sections,
    meta: {
      titleKey: "seo.sections.title",
      descriptionKey: "seo.sections.description",
    },
  },
  {
    path: "/teachers",
    name: "Teachers",
    component: Teachers,
    meta: {
      titleKey: "seo.teachers.title",
      descriptionKey: "seo.teachers.description",
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
    meta: {
      titleKey: "seo.contact.title",
      descriptionKey: "seo.contact.description",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: {
      titleKey: "seo.notFound.title",
      descriptionKey: "seo.notFound.description",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return {
      top: 0,
      behavior: "smooth",
    };
  },
});

router.beforeEach((to, from, next) => {
  const title = to.meta.titleKey
    ? i18n.global.t(to.meta.titleKey)
    : to.meta.title || "Tech College";
  document.title = title;

  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    const description = to.meta.descriptionKey
      ? i18n.global.t(to.meta.descriptionKey)
      : to.meta.description || i18n.global.t("seo.defaultDescription");

    metaDescription.setAttribute(
      "content",
      description
    );
  }

  const isAuth = authStore.isAuth();

  if (to.meta.requiresAuth && !isAuth) {
    next("/admin");
    return;
  }

  if (to.meta.requiresGuest && isAuth) {
    next("/admin/dashboard");
    return;
  }

  next();
});

router.onError((error) => {
  console.error("Router error:", error);
});

export default router;
